export default "__VITE_ASSET__D$RHYNZC__"